import SettingValueField from './SettingValueField';
import SettingNumberField from './SettingNumberField';
import SettingJsonField from './SettingJsonField';
import SettingBooleanField from './SettingBooleanField';
import SettingDateTimeField from './SettingDateTimeField';
import SettingArrayField from './SettingArrayField';

const settingFieldConfigs = {
  string: {
    label: 'String Value',
    component: SettingValueField,
  },
  number: {
    label: 'Number Value',
    component: SettingNumberField,
  },
  json: {
    label: 'JSON Value',
    component: SettingJsonField,
  },
  boolean: {
    label: 'Boolean Value',
    component: SettingBooleanField,
  },
  date: {
    label: 'Date Value',
    component: SettingDateTimeField,
  },
  array: {
    label: 'Array Value',
    component: SettingArrayField,
  },
} as const;

export default settingFieldConfigs;
